import { Link, useLocation } from "react-router-dom";
import { useEffect, useState } from "react";
import { Heart, ArrowRight, X } from "lucide-react";
import { Button } from "./ui/button";

export default function StickyDonateBar() {
  const { pathname } = useLocation();
  const [show, setShow] = useState(false);
  const [dismissed, setDismissed] = useState(false);

  // Don't show on any donate/give page itself
  const hideOnPath = pathname === "/donate" || pathname === "/give";

  useEffect(() => {
    if (hideOnPath || dismissed) {
      setShow(false);
      return;
    }
    const onScroll = () => setShow(window.scrollY > 600);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, [hideOnPath, dismissed]);

  if (hideOnPath || dismissed) return null;

  return (
    <div
      className={`fixed bottom-0 left-0 right-0 z-40 transition-all duration-500 ${
        show ? "translate-y-0 opacity-100" : "translate-y-full opacity-0 pointer-events-none"
      }`}
      data-testid="sticky-donate-bar"
    >
      <div className="bg-forest text-bone shadow-[0_-10px_40px_rgba(0,0,0,0.18)] border-t border-bone/10">
        <div className="max-w-7xl mx-auto px-4 md:px-10 lg:px-16 py-3.5 flex items-center gap-4">
          <div className="flex items-center gap-3 flex-1 min-w-0">
            <div className="w-10 h-10 shrink-0 rounded-full bg-terracotta flex items-center justify-center">
              <Heart className="w-4 h-4 text-bone fill-bone" strokeWidth={1.5}/>
            </div>
            <div className="min-w-0">
              <div className="flex items-center gap-2 text-[10px] uppercase tracking-[0.2em] text-honey font-bold mb-0.5">
                <span className="relative flex h-1.5 w-1.5">
                  <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-honey opacity-75"></span>
                  <span className="relative inline-flex rounded-full h-1.5 w-1.5 bg-honey"></span>
                </span>
                Urgent
              </div>
              <p className="text-sm font-medium leading-snug truncate">
                <span className="hidden sm:inline">This fundraiser is in urgent need of support. </span>
                <span className="text-bone/70">300+ dogs need you this summer.</span>
              </p>
            </div>
          </div>
          <Link to="/donate" data-testid="sticky-donate-cta" className="shrink-0">
            <Button className="bg-terracotta hover:bg-terracotta-deep text-bone rounded-full h-11 px-5 lg:px-7 font-semibold group">
              <span className="hidden sm:inline">Donate Now</span>
              <span className="sm:hidden">Donate</span>
              <ArrowRight className="w-4 h-4 ml-1.5 transition-transform group-hover:translate-x-1" strokeWidth={1.8}/>
            </Button>
          </Link>
          <button
            onClick={() => setDismissed(true)}
            aria-label="Dismiss"
            className="shrink-0 w-8 h-8 rounded-full hover:bg-bone/10 flex items-center justify-center text-bone/60 hover:text-bone transition-colors"
            data-testid="sticky-donate-dismiss"
          >
            <X className="w-4 h-4" strokeWidth={1.5}/>
          </button>
        </div>
      </div>
    </div>
  );
}
